import React, { useState } from "react";
import { createContext } from "react";
// types
import { IPartner, IPartnerMinimum } from "@src/api/partner/partner";
import {
  communityModalDataProps,
  IReviewProviderData,
  IReviewDataDetail,
  ISpecificComment,
  IReviewImageData,
  TFilterType,
  TTabType,
} from "./Intreface";
// review
import { ICommunityCommentListItem, ICommunityListItem } from "@src/api/community/community";
import { TPartnerType } from "../interface";

// provider data
export const ReviewProviderData = createContext<null | {
  data: IReviewProviderData;
  setData?: React.Dispatch<React.SetStateAction<IReviewProviderData>>;
}>(null);

// Provider Component
export const ReviewProviderComponent = ({
  partnerDataProvider,
  apiFunctionProvider,
  parentTabNumberProvider,
  partnerTypeProvider,
  children,
}: {
  partnerDataProvider?: IPartner | IPartnerMinimum;
  apiFunctionProvider?: any;
  parentTabNumberProvider?: number;
  partnerTypeProvider?: TPartnerType;
  children: React.ReactNode;
}) => {
  // 파트너 데이터
  const [partner, setPartner] = useState<IPartner | IPartnerMinimum | null>(
    partnerDataProvider || null,
  );

  // 리프레시 플래그
  const [refreshFlag, setRefreshFlag] = useState<boolean>(false);

  // 커뮤니티 리뷰 리스트
  const [communityList, setCommunityList] = useState<ICommunityListItem[] | null>(null);

  // 블로그 리뷰 리스트
  const [blogReviewList, setBlogReviewList] = useState<ICommunityListItem[] | null>(null);

  // 블로그 리뷰 리스트 총 개수
  const [blogReviewTotal, setBlogReviewTotal] = useState<number>(0);

  // 블라인드 리뷰 리스트
  const [blindList, setBlindList] = useState<ICommunityListItem[] | null>(null);

  // 리뷰 상세 데이터
  const [reviewDataDetail, setReviewDataDetail] = useState<IReviewDataDetail | null>(null);
  const [commentList, setCommentList] = useState<ICommunityCommentListItem[] | null>(null);
  const [specificComment, setSpecificComment] = useState<ISpecificComment | null>(null);

  // 커뮤니티 모달 데이터 (신고/차단)
  const [communityModalData, setCommunityModalData] = useState<communityModalDataProps>({
    id: 0,
    category: 2,
    communityUuid: null,
    customerUuid: null,
  });

  // 리뷰 이미지 데이터
  const [reviewImageData, setReviewImageData] = useState<IReviewImageData>({
    id: 0,
    idx: 0,
    photoData: [],
    total: 0,
    reviewUuid: "",
  });

  // 리뷰 모든 지점 보기 상태
  const [showAllReview, setShowAllReview] = useState<boolean>(false);

  // 활성화 탭 (커뮤니티 리뷰/블로그 리뷰)
  const [activeReviewTab, setActiveReviewTab] = useState<TTabType>(0);

  // 리뷰 리스트 필터 (최신순, 베스트순)
  const [filter, setFilter] = useState<TFilterType>("베스트순");
  const [filterModalIsOpen, setFilterModalIsOpen] = useState<boolean>(false);

  // braodcast
  const reviewBroadcast = new BroadcastChannel("review-webview");
  const [broadcast, setBroadcast] = useState<BroadcastChannel | null>(
    "BroadcastChannel" in window ? reviewBroadcast : null,
  );

  return (
    <ReviewProviderData.Provider
      value={{
        data: {
          partner,
          setPartner,
          refreshFlag,
          setRefreshFlag,
          partnerType: partnerTypeProvider ? partnerTypeProvider : "default",
          parentTabNumber: parentTabNumberProvider,
          getCommunityList: apiFunctionProvider?.getCommunityList,
          getBlogList: apiFunctionProvider?.getBlogList,
          getBlindList: apiFunctionProvider?.getBlindList,
          reviewDataDetail,
          setReviewDataDetail,
          communityList,
          setCommunityList,
          blogReviewList,
          setBlogReviewList,
          blogReviewTotal,
          setBlogReviewTotal,
          blindList,
          setBlindList,
          commentList,
          setCommentList,
          specificComment,
          setSpecificComment,
          communityModalData,
          setCommunityModalData,
          reviewImageData,
          setReviewImageData,
          showAllReview,
          setShowAllReview,
          filter,
          setFilter,
          filterModalIsOpen,
          setFilterModalIsOpen,
          activeReviewTab,
          setActiveReviewTab,
          broadcast,
          setBroadcast,
        },
      }}
    >
      {children}
    </ReviewProviderData.Provider>
  );
};
